export default __webpack_public_path__ + "static/media/detail_big_10_6.1f68385c.jpg";